// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner .messageBox {\n  display: inline-block;\n}\n.banner .messageButton {\n  cursor: pointer;\n  color: blue;\n  text-decoration: underline;\n}\n.banner .messageContent, .banner .messageTitle {\n  display: none;\n}\n.banner .v-avatar.v-banner__icon {\n  margin-right: 10px;\n}\n.banner .v-banner .v-banner__actions {\n  margin-bottom: 0px;\n  margin-left: 0px;\n}\n.banner .v-banner .v-banner__wrapper {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
